module.exports = __webpack_public_path__ + "img/success.2a81d0ac.jpg";